export default {
  text: ['text/plain'],
  simpleImage: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'],
  image: ['image/gif', 'image/jpeg', 'image/png', 'image/tiff', 'image/heic', 'image/heif', '.heic', '.heif'],
  pdf: ['application/pdf'],
  csv: ['text/csv']
}